export const fontFamilies = {
  Rubik: '"Rubik", sans-serif',
  Roboto: '"Roboto", sans-serif',
};

export const Fonts = {
  /* Rubik: Used for headlines */
  RubikRegular: {
    fontFamily: fontFamilies.Rubik,
    fontWeight: '400'
  },
  RubikMedium: {
    fontFamily: fontFamilies.Rubik,
    fontWeight: '500'
  },
  /* Roboto: Used for body text*/
  RobotoRegular: {
    fontFamily: fontFamilies.Roboto,
    fontWeight: '400'
  },
  RobotoMedium: {
    fontFamily: fontFamilies.Roboto,
    fontWeight: '500'
  },
  RobotoBold: {
    fontFamily: fontFamilies.Roboto,
    fontWeight: '700'
  },
};
